/*globals angular*/
'use strict';
angular
    .module('MW.Influencers.IcmLanguageService', [])
    .factory('IcmLanguageService', [ function () {
        var languageServiceObj = {},
            languageList,
            languageDictionary,
            updateLanguages;

        updateLanguages = function updateLanguages (languages) {
            // Hold original array to optimize for literal return of getLanguageList
            languageList = languages;

            // Copy values to optimize for lookup
            languageDictionary = {};
            for(var i = 0; i < languages.length; i++) {
                languageDictionary[languages[i].val] = languages[i];
            }
        };

        languageServiceObj.getLanguageList = function () {
            return languageList;
        };

        languageServiceObj.getLanguage = function getLanguage (code) {
            return languageDictionary[code];
        };

        languageServiceObj.isAsianLanguage = function isAsianLanguage (language) {
            return ['jp', 'cn', 'kp', 'kr'].indexOf(language) !== -1;
        };

        updateLanguages([
            {val:'ar',name:'Arabic'},
            {val:'bg',name:'Bulgarian'},
            {val:'bn',name:'Bengali'},
            {val:'cs',name:'Czech'},
            {val:'da',name:'Danish'},
            {val:'de',name:'German'},
            {val:'el',name:'Greek'},
            {val:'en',name:'English'},
            {val:'es',name:'Spanish / Castilian'},
            {val:'et',name:'Estonian'},
            {val:'fa',name:'Persian'},
            {val:'fi',name:'Finnish'},
            {val:'fr',name:'French'},
            {val:'he',name:'Hebrew'},
            {val:'hi',name:'Hindi'},
            {val:'hr',name:'Croatian'},
            {val:'hu',name:'Hungarian'},
            {val:'it',name:'Italian'},
            {val:'ja',name:'Japanese'},
            {val:'ko',name:'Korean'},
            {val:'lt',name:'Lithuanian'},
            {val:'lv',name:'Latvian'},
            {val:'mk',name:'Macedonian'},
            {val:'ms',name:'Malay'},
            {val:'ne',name:'Nepali'},
            {val:'nl',name:'Dutch'},
            {val:'no',name:'Norwegian'},
            {val:'pl',name:'Polish'},
            {val:'pt',name:'Portuguese'},
            {val:'ro',name:'Romanian'},
            {val:'ru',name:'Russian'},
            {val:'sk',name:'Slovak'},
            {val:'sl',name:'Slovenian'},
            {val:'so',name:'Somali'},
            {val:'se',name:'Northern Sami'},
            {val:'sq',name:'Albanian'},
            {val:'sv',name:'Swedish'},
            {val:'sw',name:'Swahili'},
            {val:'tr',name:'Turkish'},
            {val:'uk',name:'Ukrainian'},
            {val:'ur',name:'Urdu'},
            {val:'vi',name:'Vietnamese'},
            {val:'kn',name:'Kannada'},
            {val:'ml',name:'Malayalam'},
            {val:'mr',name:'Marathi'},
            {val:'pa',name:'Punjabi'},
            {val:'ta',name:'Tamil'},
            {val:'te',name:'Telugu'},
            {val:'th',name:'Thai'},
            {val:'af',name:'Afrikaans'},
            {val:'am',name:'Amharic'},
            {val:'hy',name:'Armenian'},
            {val:'az',name:'Azerbaijani'},
            {val:'eu',name:'Basque'},
            {val:'be',name:'Belarusian'},
            {val:'bs',name:'Bosnian'},
            {val:'my',name:'Burmese'},
            {val:'ca',name:'Catalan'},
            {val:'km',name:'Central Khmer'},
            {val:'zh-Hans',name:'Chinese (simpl.)'},
            {val:'zh-Hant',name:'Chinese (trad.)'},
            {val:'fo',name:'Faroese'},
            {val:'tl',name:'Filipino'},
            {val:'gl',name:'Galician'},
            {val:'ka',name:'Georgian'},
            {val:'gu',name:'Gujarati'},
            {val:'ha',name:'Hausa'},
            {val:'is',name:'Icelandic'},
            {val:'id',name:'Indonesian'},
            {val:'ga',name:'Irish'},
            {val:'kl',name:'Kalaallisut, Greenlandic'},
            {val:'kk',name:'Kazakh'},
            {val:'rw',name:'Kinyarwanda'},
            {val:'ky',name:'Kirghiz, Kyrgyz'},
            {val:'ku',name:'Kurdish'},
            {val:'lo',name:'Lao'},
            {val:'lb',name:'Luxembourgish'},
            {val:'mt',name:'Maltese'},
            {val:'el',name:'Modern Greek'},
            {val:'he',name:'Modern Hebrew'},
            {val:'nd',name:'North Ndebele'},
            {val:'ps',name:'Pashto, Pushto'},
            {val:'rm',name:'Romansh'},
            {val:'sr',name:'Serbian'},
            {val:'si',name:'Sinhala, Sinhalese'},
            {val:'nr',name:'South Ndebele'},
            {val:'uz',name:'Uzbek'},
            {val:'cy',name:'Welsh'},
            {val:'zu',name:'Zulu'},
            {val:'as',name:'Assamese'},
            {val:'xh',name:'Xhosa'},
            {val:'mi',name:'Māori'},
            {val:'eo',name:'Esperanto'},
            {val:'fj',name:'Fijian'},
            {val:'la',name:'Latin'},
            {val:'mn',name:'Mongolian'},
            {val:'sm',name:'Samoan'},
            {val:'yi',name:'Yiddish'},
            {val:'or',name:'Oriya'},
            {val:'mg',name:'Malagasy'},
            {val:'dv',name:'Dhivehi'}
        ]);

        return languageServiceObj;
    }]);
